import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Collapse } from '@stashinvest/ui';
import { ChevronDownIcon } from '@stashinvest/ui/dist/es/2';
import { InfoToggleContent, InfoToggleLink } from './InfoToggle.styles';

const InfoToggle = (props) => {
	const [isOpen, setIsOpen] = useState(false);
	const {
		align,
		children,
		disabled,
		marginLeft,
		toggleText,
		fontSize,
		fontWeight,
		infoToggleEvent,
	} = props;
	const onToggle = (e, disabled) => {
		e.preventDefault();
		if (!disabled) {
			setIsOpen((prevState) => !prevState);
		}
	};

	return (
		<Box>
			<Box align={align ? align : 'center'} mb="s">
				<InfoToggleLink
					href="#toggle"
					fontSize={fontSize}
					fontWeight={fontWeight}
					isOpen={isOpen}
					marginLeft={marginLeft}
					onClick={(e) => {
						if (infoToggleEvent) {
							infoToggleEvent();
						}
						onToggle(e, disabled);
					}}
				>
					{toggleText}
					<ChevronDownIcon />
				</InfoToggleLink>
			</Box>
			<Collapse isOpened={isOpen}>
				<InfoToggleContent fontSize={fontSize}>{children}</InfoToggleContent>
			</Collapse>
		</Box>
	);
};

InfoToggle.propTypes = {
	align: PropTypes.string,
	disabled: PropTypes.bool,
	children: PropTypes.node,
	toggleText: PropTypes.string,
	fontSize: PropTypes.string,
	marginLeft: PropTypes.string,
	fontWeight: PropTypes.string,
	infoToggleEvent: PropTypes.func,
};

export default InfoToggle;
